import { render, staticRenderFns } from "./PermohonanList.vue?vue&type=template&id=15965600&scoped=true&"
import script from "./PermohonanList.vue?vue&type=script&lang=js&"
export * from "./PermohonanList.vue?vue&type=script&lang=js&"
import style0 from "./PermohonanList.vue?vue&type=style&index=0&id=15965600&lang=scss&scoped=true&"
import style1 from "./PermohonanList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15965600",
  null
  
)

export default component.exports